/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Rocket.net API
 * Rocket.net - All APIs
 * OpenAPI spec version: 1.0.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import { customFetch } from '../../custom-fetch';
import { addMetaToMutation } from '../../mutators/add-meta';
import type {
  Error,
  PurgeCacheRequest,
  PurgeCacheResponse,
  PurgeSiteCacheEverythingParams,
  PurgeSiteCachePartialParams,
  SiteID,
} from '../rocketNetAPI.schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * Clears cached copies of specific URLs or cache tags from the site's CDN. Use optional staging, domain, and include_additional_domains query parameters to target staging or specific domains.
 * @summary Purge specific cached URLs
 */
export const purgeSiteCachePartial = (
  id: SiteID,
  purgeCacheRequest: PurgeCacheRequest,
  params?: PurgeSiteCachePartialParams,
  signal?: AbortSignal
) => {
  return customFetch<PurgeCacheResponse>({
    url: `/v1/sites/${id}/cache/purge`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: purgeCacheRequest,
    params,
    signal,
  });
};

export const getPurgeSiteCachePartialMutationOptions = <
  TError = Error,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof purgeSiteCachePartial>>,
    TError,
    { id: SiteID; data: PurgeCacheRequest; params?: PurgeSiteCachePartialParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof purgeSiteCachePartial>>,
  TError,
  { id: SiteID; data: PurgeCacheRequest; params?: PurgeSiteCachePartialParams },
  TContext
> => {
  const mutationKey = ['purgeSiteCachePartial'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof purgeSiteCachePartial>>,
    { id: SiteID; data: PurgeCacheRequest; params?: PurgeSiteCachePartialParams }
  > = props => {
    const { id, data, params } = props ?? {};

    return purgeSiteCachePartial(id, data, params);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/cache/purge` },
    {
      operationId: 'app.controllers.cdn_cache_controller.purge_site_cache_partial',
      operationName: 'purgeSiteCachePartial',
    }
  );

  return customOptions;
};

export type PurgeSiteCachePartialMutationResult = NonNullable<
  Awaited<ReturnType<typeof purgeSiteCachePartial>>
>;
export type PurgeSiteCachePartialMutationBody = PurgeCacheRequest;
export type PurgeSiteCachePartialMutationError = Error;

/**
 * @summary Purge specific cached URLs
 */
export const usePurgeSiteCachePartial = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof purgeSiteCachePartial>>,
      TError,
      { id: SiteID; data: PurgeCacheRequest; params?: PurgeSiteCachePartialParams },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof purgeSiteCachePartial>>,
  TError,
  { id: SiteID; data: PurgeCacheRequest; params?: PurgeSiteCachePartialParams },
  TContext
> => {
  const mutationOptions = getPurgeSiteCachePartialMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Clears all cached content for the site's CDN. Warning: this temporarily slows page loads until content is re-cached. Supports staging, domain, and include_additional_domains query parameters.
 * @summary Purge entire site cache
 */
export const purgeSiteCacheEverything = (
  id: SiteID,
  params?: PurgeSiteCacheEverythingParams,
  signal?: AbortSignal
) => {
  return customFetch<PurgeCacheResponse>({
    url: `/v1/sites/${id}/cache/purge_everything`,
    method: 'POST',
    params,
    signal,
  });
};

export const getPurgeSiteCacheEverythingMutationOptions = <
  TError = Error,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof purgeSiteCacheEverything>>,
    TError,
    { id: SiteID; params?: PurgeSiteCacheEverythingParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof purgeSiteCacheEverything>>,
  TError,
  { id: SiteID; params?: PurgeSiteCacheEverythingParams },
  TContext
> => {
  const mutationKey = ['purgeSiteCacheEverything'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof purgeSiteCacheEverything>>,
    { id: SiteID; params?: PurgeSiteCacheEverythingParams }
  > = props => {
    const { id, params } = props ?? {};

    return purgeSiteCacheEverything(id, params);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/cache/purge_everything` },
    {
      operationId: 'app.controllers.cdn_cache_controller.purge_site_cache_everything',
      operationName: 'purgeSiteCacheEverything',
    }
  );

  return customOptions;
};

export type PurgeSiteCacheEverythingMutationResult = NonNullable<
  Awaited<ReturnType<typeof purgeSiteCacheEverything>>
>;

export type PurgeSiteCacheEverythingMutationError = Error;

/**
 * @summary Purge entire site cache
 */
export const usePurgeSiteCacheEverything = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof purgeSiteCacheEverything>>,
      TError,
      { id: SiteID; params?: PurgeSiteCacheEverythingParams },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof purgeSiteCacheEverything>>,
  TError,
  { id: SiteID; params?: PurgeSiteCacheEverythingParams },
  TContext
> => {
  const mutationOptions = getPurgeSiteCacheEverythingMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
